import React from 'react';

const Format9 = ({ modifyForm = {} }) => {

  // ── Dummy data ───────────────────────────────────────────────────────────────
  const DUMMY = {
    company: {
      name:    'Demo Company Pvt. Ltd.',
      addr1:   '125, Industrial Area, Sector 5',
      addr2:   'Indore, Madhya Pradesh - 452001',
      phone:   '9876543210',
      email:   'company@demo.in',
      gst:     '23AABCU9603R1ZX',
      pan:     'AABCU9603R',
      fssai:   '12345678901234',
      city:    'Indore',
    },
    branch: {
      name:    'Demo Branch Office',
      addr1:   'Opp. Bus Stand, MG Road',
      addr2:   'Bhopal, Madhya Pradesh - 462001',
      phone:   '9111222333',
      email:   'branch@demo.in',
      gst:     '23BBBCU9603R1ZY',
      pan:     'BBBCU9603R',
      fssai:   '98765432101234',
      city:    'Bhopal',
    },
  };

  const src   = modifyForm?.address === 'branch' ? DUMMY.branch : DUMMY.company;
  const terms = modifyForm?.terms_conds || 'The consignment covered by this set of special Lorry Receipt from shall be stored at the Destination under the control of the transport operator and shall be delivered to the order of the consignee bank whose name is mentioned in the lorry receipt.';

  // ── Columns ──────────────────────────────────────────────────────────────────
  const defaultCols = [
    { name: 'Product Description', check: true },
    { name: 'No. of Article',      check: true },
    { name: 'KOT',                 check: true },
    { name: 'Weight',              check: true },
  ];
  const allCols    = modifyForm?.lr_table?.length > 0 ? modifyForm.lr_table : defaultCols;
  const visCols    = allCols.filter(c => c.check);
  const [fCol, ...rCols] = visCols;

  const ROWS = 13;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css?family=Roboto:400,500,700,900&display=swap');
        .f9 *        { box-sizing: border-box; }
        .f9          { font-family:'Roboto',sans-serif; font-size:12px; line-height:1.4; color:#000; }
        .f9 table    { width:100%; border-collapse:collapse; }
        .f9 td       { vertical-align:top; }
        .f9-box      { border:1px solid #ccc; }

        /* header */
        .f9-jur      { font-size:10px; text-align:center; margin:4px 0; }
        .f9-hdr      { padding:5px 10px 7px; border-bottom:1px solid #ccc; text-align:center; }
        .f9-hdr-name { display:block; font-size:24px; font-weight:900; margin-bottom:2px; }
        .f9-hdr-sub  { display:block; font-size:11px; margin:1px 0; }
        .f9-hdr-gst  { display:block; font-size:11px; font-weight:900; margin-top:3px; }

        /* strip */
        .f9-strip           { display:flex; border-bottom:1px solid #ccc; }
        .f9-strip > div     { flex:1; padding:5px 8px; border-right:1px solid #ccc; }
        .f9-strip > div:last-child { border-right:none; }
        .f9-strip-lbl       { font-size:10px; margin:0; color:#555; }
        .f9-strip-val       { font-size:12px; font-weight:700; margin:0; }

        /* route */
        .f9-route { text-align:center; font-size:14px; font-weight:700; padding:6px 8px; border-bottom:1px solid #ccc; }

        /* consign */
        .f9-cr      { display:flex; border-bottom:1px solid #ccc; }
        .f9-cc      { flex:1; padding:5px 8px; }
        .f9-cc:first-child { border-right:1px solid #ccc; }
        .f9-irow    { display:flex; font-size:10px; margin-bottom:3px; }
        .f9-ilbl    { flex-basis:65px; flex-shrink:0; color:#555; }
        .f9-ival    { flex:1; font-weight:500; }

        /* body */
        .f9-body    { display:flex; min-height:330px; }

        /* left */
        .f9-lp      { width:168px; flex-shrink:0; border-right:1px solid #ccc; display:flex; flex-direction:column; justify-content:space-between; }
        .f9-df      { padding:8px 6px 6px 10px; }
        .f9-drow    { display:flex; font-size:10px; margin-bottom:7px; align-items:flex-end; gap:3px; }
        .f9-drow span:first-child { white-space:nowrap; }
        .f9-dval    { font-weight:600; margin-left:2px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:80px; }
        .f9-dline   { flex:1; border-bottom:1px solid #bbb; margin-bottom:1px; }
        .f9-tc      { border-top:1px solid #ccc; padding:5px 8px 6px; }
        .f9-tc-t    { font-size:10px; font-weight:700; margin:0 0 3px; }
        .f9-tc-p    { font-size:7.5px; color:#444; line-height:1.4; margin:0 0 4px; }
        .f9-tc-h    { font-size:7.5px; color:#444; line-height:1.4; margin:0; }

        /* mid */
        .f9-mp      { flex:1; display:flex; flex-direction:column; }
        .f9-tbl     { width:100%; border-collapse:collapse; }
        .f9-th      { font-size:10px; padding:5px 8px; border-bottom:1px solid #ccc; font-weight:600; background:#fff; color:#000; }
        .f9-thc     { font-size:10px; padding:5px 8px; border-bottom:1px solid #ccc; font-weight:600; text-align:center; border-left:1px solid #ccc; background:#fff; color:#000; }
        .f9-td      { font-size:10px; padding:3px 8px; height:21px; border-top:1px solid #f0f0f0; }
        .f9-tdc     { font-size:10px; padding:3px 8px; height:21px; text-align:center; border-left:1px solid #ccc; border-top:1px solid #f0f0f0; }
        .f9-fval    { display:flex; gap:6px; align-items:center; padding:4px 8px; font-size:10px; border-top:1px solid #ccc; border-bottom:1px solid #ccc; }
        .f9-fline   { flex:1; border-bottom:1px solid #888; }
        .f9-ftot    { display:flex; align-items:center; border-top:1px solid #ccc; }
        .f9-ftot-l  { flex:1; text-align:right; padding:3px 8px; font-size:10px; font-weight:700; }
        .f9-ftot-c  { padding:3px 8px; font-size:10px; font-weight:700; border-left:1px solid #ccc; text-align:center; }

        /* right */
        .f9-rp      { width:148px; flex-shrink:0; border-left:1px solid #ccc; display:flex; flex-direction:column; justify-content:space-between; }
        .f9-tbf     { font-size:10px; font-weight:700; text-align:center; padding:5px 8px; border-bottom:1px solid #ccc; }
        .f9-stamp   { font-size:8px; text-align:center; color:#999; padding:6px 14px; line-height:1.5; }
        .f9-sig     { border-top:1px solid #ccc; height:52px; display:flex; justify-content:center; align-items:flex-end; padding-bottom:5px; }
        .f9-sig span{ font-size:10px; text-align:center; }

        .f9-sc { width:210mm; margin:0 auto; transform-origin:top left; }
        @media (max-width:767px) { .f9-sc { transform:scale(0.42) !important; transform-origin:0 0; } }
        @media print { .f9-sc { transform:scale(1) !important; } }
      `}</style>

      <div className="f9-sc">
        <div style={{ padding: '2mm', background: '#fff' }}>
          <div className="f9">
            <div className="f9-box">

              {/* Jurisdiction */}
              <p className="f9-jur">Subject to {src.city} Jurisdiction</p>

              {/* Header */}
              <div className="f9-hdr">
                <span className="f9-hdr-name">{src.name}</span>
                <span className="f9-hdr-sub">{src.addr1}</span>
                <span className="f9-hdr-sub">{src.addr2}</span>
                <span className="f9-hdr-sub">Contact: +91 {src.phone} | Email: {src.email}</span>
                <span className="f9-hdr-gst">GST: {src.gst} | PAN: {src.pan} | FSSAI: {src.fssai}</span>
              </div>

              {/* Dispatch Strip */}
              <div className="f9-strip">
                {[
                  { lbl: 'Dispatch Date', val: '31/03/2026'   },
                  { lbl: 'Truck Number',  val: 'RJ11GD3421'   },
                  { lbl: 'Truck Type',    val: 'Hyva 6 Tyres' },
                  { lbl: 'Trip Number',   val: 'T6-2025-203'  },
                  { lbl: 'LR Number',     val: 'B6-2025-261'  },
                ].map((x, i) => (
                  <div key={i}>
                    <p className="f9-strip-lbl">{x.lbl}</p>
                    <p className="f9-strip-val">{x.val}</p>
                  </div>
                ))}
              </div>

              {/* Route */}
              <div className="f9-route">1 B BARANI &nbsp;-&nbsp; ANKLESVAR</div>

              {/* Consignor / Consignee */}
              <div className="f9-cr">
                <div className="f9-cc">
                  {[
                    ['Consignor', 'CR23-2026 | Rama Logistics'],
                    ['Pickup',    'Rama Warehouse, Sector 12'],
                    ['Address',   'Indore, MP - 452001'],
                  ].map(([l, v], i) => (
                    <div key={i} className="f9-irow">
                      <span className="f9-ilbl">{l}</span>
                      <span className="f9-ival">{v}</span>
                    </div>
                  ))}
                </div>
                <div className="f9-cc">
                  {[
                    ['Consignee', 'XYZ Distributors Pvt. Ltd.'],
                    ['Contact',   '9988776655'],
                    ['Address',   'Anklesvar, Gujarat - 393001'],
                  ].map(([l, v], i) => (
                    <div key={i} className="f9-irow">
                      <span className="f9-ilbl">{l}</span>
                      <span className="f9-ival">{v}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Body */}
              <div className="f9-body">

                {/* Left Panel */}
                <div className="f9-lp">
                  <div className="f9-df">
                    {[
                      ['Driver Name',    'Driver Virendra'],
                      ['Driver Contact', '9753725878'],
                      ['License no.',    'MP09 20230012345'],
                      ['Aadhar Number',  ''],
                      ['Eway Bill No.',  ''],
                      ['Invoice No.',    ''],
                    ].map(([lbl, val], i) => (
                      <div key={i} className="f9-drow">
                        <span>{lbl}</span>
                        {val
                          ? <span className="f9-dval">{val}</span>
                          : <span className="f9-dline"></span>
                        }
                      </div>
                    ))}
                  </div>
                  <div className="f9-tc">
                    <p className="f9-tc-t">Terms & Conditions</p>
                    <p className="f9-tc-p">{terms}</p>
                    <p className="f9-tc-h">गाड़ी खाली होने के 10 दिन तक (ACKNOWLEDGEMENT) (पहुँच) हमारे ऑफिस में जमा होनी चाहिए, अन्यथा बकाया (भाड़ा) नहीं दिया जाएगा</p>
                  </div>
                </div>

                {/* Mid Panel */}
                <div className="f9-mp">
                  <table className="f9-tbl">
                    <thead>
                      <tr>
                        {fCol && <td className="f9-th">{fCol.label ?? fCol.name}</td>}
                        {rCols.map((col, i) => (
                          <td key={i} className="f9-thc">{col.label ?? col.name}</td>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {/* one dummy row with 0s */}
                      <tr>
                        {fCol && <td className="f9-td">&nbsp;</td>}
                        {rCols.map((_, c) => <td key={c} className="f9-tdc">0</td>)}
                      </tr>
                      {[...Array(ROWS)].map((_, r) => (
                        <tr key={r}>
                          {fCol && <td className="f9-td">&nbsp;</td>}
                          {rCols.map((_, c) => <td key={c} className="f9-tdc">&nbsp;</td>)}
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {/* Value row */}
                  <div className="f9-fval">
                    <span>Value</span>
                    <span style={{ fontWeight: 600 }}>100000000</span>
                    <span className="f9-fline"></span>
                    {rCols.map((_, i) => <span key={i} style={{ width: 52 }}></span>)}
                  </div>

                  {/* Total row */}
                  <div className="f9-ftot">
                    <div className="f9-ftot-l">Total</div>
                    {rCols.map((_, i) => (
                      <div key={i} className="f9-ftot-c">0</div>
                    ))}
                  </div>
                </div>

                {/* Right Panel */}
                <div className="f9-rp">
                  <div>
                    <div className="f9-tbf">TO BE FILLED</div>
                    <div className="f9-stamp">Please Acknowledge with Rubber Stamp &amp; Signature</div>
                  </div>
                  <div>
                    <div className="f9-sig"><span>Signature of Driver/ Owner</span></div>
                    <div className="f9-sig"><span>Signature of Staff</span></div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Format9; 